/**
 * Time Log Chart Component
 */
import { TimeLogSummary } from '@/types';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface TimeLogChartProps {
  data: TimeLogSummary[];
}

export const TimeLogChart: React.FC<TimeLogChartProps> = ({ data }) => {
  const chartData = data.map((item) => ({
    name: item.user_name,
    hours: item.total_hours,
    tasks: item.task_count,
  }));

  return (
    <div className="card">
      <h3 className="text-lg font-semibold mb-4">Time Log Summary</h3>
      
      {data.length === 0 ? (
        <div className="text-center py-8 text-gray-400">
          No time logs available
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="hours" fill="#3b82f6" name="Hours Logged" />
            <Bar dataKey="tasks" fill="#10b981" name="Tasks Worked" />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};


